var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('home-header',{attrs:{"title":_vm.i18n('Administration')}}),_vm._v(" "),_c('home-grid',{attrs:{"users":"","settings":"","reports":"","logs":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }